import { SupplementalData } from '@dispatch/shared/types';
import { CreateField } from './SupplementalDataHelper';
import { Section } from '@dispatch/web/ui';
import { Grid } from '@mui/material';

export type SupplementalDataTabProps = {
  data: SupplementalData[];
};

export function SupplementalDataTab({ data }: SupplementalDataTabProps) {
  return (
    <div
      style={{
        padding: '24px',
      }}
    >
      <Section title="Supplemental Data">
        <Grid container spacing={3}>
          {data.map((info) => CreateField(info))}
        </Grid>
      </Section>
    </div>
  );
}
